import React from 'react';
import {View, Text} from 'react-native';
import {Components, Font} from '@oneamerica/dxp-ui-components';
import responsiveStyle from '../../style';
import InfoWrapper from '../../../../components/InfoWrapper/InfoWrapper';
import ColorConstants from '../../../../constants/ColorConstants';
import {formatCurrency, formatDate} from '../../../../utils';
import {analyticsTags} from '../../../../utils/Analytics/AnalyticsTags';
import {trackCustomEvent} from '../../../../utils/Analytics/AdobeAnalyticsUtils';

interface LoansCardProps {
  className: any;
  loansData: {
    amount: number;
    decimal: number;
    integer: number;
    percent: number;
    text: string | null;
    type: string;
    policyLoan?: {
      asOfDate: string;
      interestMethod: string;
      interestRateCharged: number;
      interestRateCrtd: number;
      interestRatePaid: number;
      loanBalance: number;
      loanPayOff: number;
      netInterestRate: number;
      prefLoanInterestFactor: number;
      typeOfInterestRateCharged: string;
      valueAvailable: number;
    };
  };
  row: any;
  linkStyle: any;
  navigateToPolicyDetails: any;
}

export const LoansCard = ({
  className,
  loansData,
  row,
  linkStyle,
  navigateToPolicyDetails,
}: LoansCardProps) => {
  const style = responsiveStyle();

  return loansData ? (
    <View className={className}>
      <View style={[style.cardShadow, row > 1 && style.flex]}>
        <View style={style.cardHeader}>
          <Components.Text.H3 style={[style.cardHeaderTitle, style.flex]}>
            Loans
          </Components.Text.H3>
        </View>
        {loansData?.policyLoan?.asOfDate && (
          <Text
            style={{
              fontSize: 14,
              fontFamily: Font.light.fontFamily,
              color: ColorConstants.iron,
            }}>
            As of{' '}
            {formatDate(loansData?.policyLoan?.asOfDate, 'MMM DD, YYYY', '-')}
          </Text>
        )}
        <View className="mt-4" style={style.horizontalDivider} />
        <View style={style.contentWrapper}>
          <View className="py-2" style={style.row}>
            <View className="items-center" style={style.flex}>
              <View>
                {loansData?.policyLoan?.loanBalance &&
                  loansData?.policyLoan?.loanBalance > 0 && (
                    <InfoWrapper
                      title={loansData.type}
                      information={formatCurrency(
                        loansData?.policyLoan?.loanBalance,
                      )}
                      boldInfo
                      centerAlign
                    />
                  )}
                {loansData?.policyLoan?.valueAvailable != null &&
                loansData?.policyLoan?.valueAvailable >= 0 ? (
                  <View className="my-2" style={style.horizontalDivider} />
                ) : null}
              </View>
              {loansData?.policyLoan?.valueAvailable != null &&
              loansData?.policyLoan?.valueAvailable >= 0 ? (
                <InfoWrapper
                  title={'Available Loan Value'}
                  information={formatCurrency(
                    loansData?.policyLoan?.valueAvailable,
                  )}
                  subTitle
                  centerAlign
                />
              ) : null}
            </View>
          </View>
        </View>
        <Components.Link
          accessibilityLabel="View Loan Details"
          accessibilityRole="button"
          onPress={() => {
            trackCustomEvent(analyticsTags.CaptureLoansCardViewDetailsTags);
            navigateToPolicyDetails('LoansInformation');
          }}
          {...linkStyle}>
          View Details
        </Components.Link>
      </View>
    </View>
  ) : null;
};
